import { render } from "./ProfesseursDetailsPage.vue?vue&type=template&id=12d3dbe6"
import script from "./ProfesseursDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProfesseursDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__